import { g as o } from "./index767.mjs";
var r = o, s = r.Promise;
export {
  s as p
};
